module.exports = __webpack_public_path__ + "static/img/slide_small0.0327c52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slide_small0.png
// module id = Nody
// module chunks = 5